module.exports = __webpack_public_path__ + "img/cusSer@2x.307bb385.png";